import { useEffect } from "react";
import { Divider, Typography, Row, Col } from "antd";
import { useLocation, useNavigate, createSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import az from "date-fns/locale/az";

import clock from "../../images/clock.svg";
import nomeeting from "../../images/nomeeting.gif";
import { setAllMeetings } from "../../redux/actions/mainAction";

const MeetingsTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);

  useEffect(() => {
    getMeetins();
  }, [GlobalResponse.triggeranyevent]);

  const getMeetins = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-meetings/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    dispatch(setAllMeetings(result));
  };

  const showMeetingDetails = (meeting) => {
    navigate({
      pathname: "/meetingoverview",
      search: createSearchParams({
        _id: meeting._id,
        meetingName: meeting.meetingName,
        meetingAuthor: meeting.meetingAuthor,
        meetingAuthorFullName: meeting.meetingAuthorFullName,
        meetingRoomName: meeting.meetingRoomName,
        meetingStartDate: meeting.meetingStartDate,
        meetingStartTime2: meeting.meetingStartTime2,
        meetingEndDate: meeting.meetingEndDate,
        meetingEndTime2: meeting.meetingEndTime2,
        meetingAttenders: [meeting.meetingAttenders],
        meetingAbout: meeting.meetingAbout,
      }).toString(),
    });
  };
  const checkMeetStatus = (
    meetingStartDate,
    meetingStartTime2,
    meetingEndDate,
    meetingEndTime2
  ) => {
    const today = new Date();
    const formattedDate = format(today, "yyyy-MM-dd", { locale: az });
    const formattedTime = format(today, "HH:mm", { locale: az });

    if (formattedDate < meetingStartDate) {
      return "Başlamayıb";
    } else if (formattedDate > meetingEndDate) {
      return "Bitib";
    } else if (
      formattedDate === meetingStartDate &&
      formattedTime < meetingStartTime2
    ) {
      return "Başlamayıb";
    } else if (
      formattedDate === meetingEndDate &&
      formattedTime > meetingEndTime2
    ) {
      return "Bitib";
    } else {
      return "Davam edir";
    }
  };

  const renderMeetingCard = (meeting) => (
    <div
      onClick={() => showMeetingDetails(meeting)}
      key={meeting._id}
      className="meetings-container-new"
    >
      <Row className="row-header">
        <Col span={8}>
          <div className="tate-time">
            <Typography.Text className="date">Status</Typography.Text>
            <Typography.Text className="time">
              {checkMeetStatus(
                meeting.meetingStartDate,
                meeting.meetingStartTime2,
                meeting.meetingEndDate,
                meeting.meetingEndTime2
              )}
            </Typography.Text>
          </div>
        </Col>

        <Col span={8}>
          <div className="divider-datetime">
            <Divider className="divider" type="vertical" />
            <div className="tate-time">
              <Typography.Text className="date">
                {meeting.meetingStartDate}
              </Typography.Text>
              <Typography.Text className="time">
                {meeting.meetingStartTime2}
              </Typography.Text>
            </div>
          </div>
        </Col>

        <Col span={8}>
          <div className="divider-datetime">
            <Divider className="divider" type="vertical" />
            <div className="tate-time">
              <Typography.Text className="date">
                {meeting.meetingEndDate}
              </Typography.Text>
              <Typography.Text className="time">
                {meeting.meetingEndTime2}
              </Typography.Text>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="row-footer">
        <Col span={5}>
          <img
            style={{ width: "42px", marginRight: "4px" }}
            src={clock}
            alt="clock"
          />
        </Col>
        <Col span={19}>
          <div className="owner-aboutmeeting">
            <Typography.Text className="title-meeting-owner">
              {meeting.meetingAuthorFullName}
            </Typography.Text>
            <Typography.Text className="about-meeting">
              {meeting.meetingName}
            </Typography.Text>
          </div>
        </Col>
      </Row>
    </div>
  );

  if (MainResponse.allMeetings.length > 0) {
    var visibleMeetings =
      location.pathname === "/"
        ? MainResponse.allMeetings.slice(0, 6)
        : MainResponse.allMeetings; // Limit to 6 items
  } else {
    visibleMeetings = 0;
  }

  return (
    <>
      {visibleMeetings.length > 0 ? (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {visibleMeetings.map((meeting) => (
            <div key={meeting._id} style={{ flex: "0 0 33.2%" }}>
              {renderMeetingCard(meeting)}
            </div>
          ))}
        </div>
      ) : (
        <Row>
          <Col span={11}>
            <div className="no-item-left">
              <img style={{ width: "142px" }} src={nomeeting} alt="nomeeting" />
            </div>
          </Col>
          <Col span={13}>
            <div className="no-item-right">
              <Typography.Text className="noitemtext">
                Görüş əlavə edilməyib
              </Typography.Text>
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

export default MeetingsTable;
